@if (bodyHtml()) {
  <iframe
    class="h-full w-full border-0"
    sandbox="allow-same-origin"
    [srcdoc]="safeBody()"
  ></iframe>
}
